module.exports = __webpack_public_path__ + "img/institution-building.b5fa0ba5.svg";